import { ProgramEngagementRecommendationsAPI } from '@cibo/core'
import { logRequestError } from '@cibo/ui'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from './queryKey'

export const useRecommendationsSummary = ({ engagementId }: { engagementId?: string }) =>
  useQuery({
    queryKey: [QUERY_KEY.PRACTICE_RECOMMENDATION, engagementId],
    enabled: !!engagementId,
    queryFn: async () =>
      // engagementId will be present due to enabled param
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ProgramEngagementRecommendationsAPI.summary(engagementId!).catch(logRequestError),
  })
